import React from 'react';
import PropTypes from 'prop-types';

import {ImageSharp} from "@mui/icons-material";

VariationImage.propTypes = {
    image: PropTypes.string
};

function VariationImage({image}) {
    return (
        <div style={{
            height: '40px',
            width: '40px',
            position: 'relative'
        }}>
            {image ? (
                <img
                    src={image}
                    alt={'variation image'}
                    style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px'
                    }}
                />
            ) : (
                <ImageSharp color={"disabled"} sx={{width: '100%', height: '100%'}}/>
            )}
        </div>
    );
}

export default VariationImage;
